import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import LegalLayout from "./legal/LegalLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReviewPage() {
  const [url, setUrl] = useState("");
  useEffect(() => { fetch(`${API}/review-link`).then((r) => r.json()).then((d) => setUrl(d.url)).catch(() => {}); }, []);

  return (
    <LegalLayout eyebrow="Merci pour votre confiance" title="Votre avis compte" updated="" testId="review-page">
      <div className="bg-white border border-md-border rounded-3xl p-8 md:p-12 text-left space-y-6">
        <div className="flex gap-1 text-md-secondary">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-7 h-7 fill-current" />)}</div>
        <p className="text-lg text-md-text/85 leading-relaxed max-w-2xl">
          Vous avez été accompagné par MD Courtage pour un crédit, une assurance ou un placement ? Votre retour d'expérience aide
          d'autres familles et entrepreneurs de Mayenne et d'Ille-et-Vilaine à choisir leur courtier. Cela prend moins d'une minute.
        </p>
        <a href={url || "#"} data-testid="review-google-btn" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-md-secondary hover:bg-md-secondaryHover text-white px-8 py-4 rounded-full font-semibold shadow-lg shadow-md-secondary/30 transition-transform hover:-translate-y-0.5">
          <Star className="w-5 h-5" /> Laisser mon avis sur Google
        </a>
        <p className="text-sm text-md-muted">Merci infiniment — Maël DUBOIS</p>
      </div>
    </LegalLayout>
  );
}
